import { render, staticRenderFns } from "./detailsDialog.vue?vue&type=template&id=acd97504&scoped=true&"
import script from "./detailsDialog.vue?vue&type=script&lang=js&"
export * from "./detailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./detailsDialog.vue?vue&type=style&index=0&id=acd97504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd97504",
  null
  
)

export default component.exports